module.exports = __webpack_public_path__ + "images/emoji/briefcase.6902c17d4525184a8c66.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/briefcase.png
// module id = 4klv
// module chunks = 13